import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { cn } from '../../utils/cn';

const dialogTitleVariants = cva('rocco-dialog-title', {
    variants: {
        variant: {
            default: 'text-lg',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DialogTitle = React.forwardRef<
    React.ElementRef<typeof DialogPrimitive.Title>,
    React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title> &
        VariantProps<typeof dialogTitleVariants>
>(({ className, variant, ...props }, ref) => (
    <DialogPrimitive.Title
        ref={ref}
        className={cn(dialogTitleVariants({ variant, className }))}
        {...props}
    />
));

DialogTitle.displayName = DialogPrimitive.Title.displayName;
